
export default {
  props: {
    isValid: Boolean,
    inputs: Object,
    template: Object,
  },

  computed: {
    _inputs: {
      set(value) {
        this.$emit('update:inputs', value)
      },

      get() {
        return this.inputs
      },
    },
  },
}
